import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { CircularProgress, Container } from '@mui/material';
import ResponsiveAppBar from '../layout/ResponsiveAppBar';
import { emailConfirmation } from '../api/auth';
import AccountContext from '../context/AccountContext';
import useClosableSnackbar from '../hooks/useClosableSnackbar';
import MfAlert from '../components/UI/Alert/MfAlert';

const EmailConfirm = () => {
  const { token } = useParams();
  const { setAccountResponse } = useContext(AccountContext);
  const { showSnackbar } = useClosableSnackbar();
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState('');

  const checkToken = async () => {
    if (token) {
      setProcessing(true);
      try {
        const r = await emailConfirmation(token);
        localStorage.setItem('user', JSON.stringify(r));
        setAccountResponse(r);
        showSnackbar('E-mail успешно подтвержден');
        navigate('/');
      } catch (e) {
        console.log(e);
        setError('Ошибка подтверждения e-mail');
      }
      setProcessing(false);
    }
  };

  useEffect(() => {
    checkToken();
  }, [token]);

  return (
    <div>
      <ResponsiveAppBar />
      <Container maxWidth="md" sx={{ textAlign: 'center', p: 5 }}>
        {processing && <CircularProgress />}
        {!processing && error && (
          <MfAlert severity="error" sx={{ textAlign: 'left' }}>
            {error}
            <div>
              <Link to="/">В агентский кабинет</Link>
            </div>
          </MfAlert>
        )}
      </Container>
    </div>
  );
};

export default EmailConfirm;
